import { useState, useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import { fetchUserProfile } from '../utils/profile';

const ROOT_ADMIN_ID = 'user_3FMl5C9CElnYwGOmdIDBIzxmLy3';
const ALLOWED_ROLES = ['educator', 'admin'];

/**
 * Sınıf panelinin erişim kapısı. Rol paylaşılan public.profiles tablosundan
 * OKUNUR — bu hook hiçbir koşulda role yazmaz (atama bitmiyo.com.tr/yonetim'de).
 */
export function useUserRole() {
  const { user, isLoaded } = useUser();
  const [profileRole, setProfileRole] = useState<string | null>(null);
  const [loadingProfile, setLoadingProfile] = useState(true);

  useEffect(() => {
    if (!isLoaded || !user) {
      setLoadingProfile(false);
      return;
    }
    let isMounted = true;
    fetchUserProfile(user.id)
      .then(profile => {
        if (isMounted) setProfileRole(profile?.role ?? null);
      })
      .finally(() => {
        if (isMounted) setLoadingProfile(false);
      });
    return () => {
      isMounted = false;
    };
  }, [user, isLoaded]);

  const isRootAdmin = user?.id === ROOT_ADMIN_ID;
  const role = isRootAdmin ? 'admin' : profileRole ?? 'user';
  const isTeacher = isRootAdmin || ALLOWED_ROLES.includes(role);

  return {
    isLoaded: isLoaded && !loadingProfile,
    isTeacher,
    role,
    user,
  };
}
